import type { ReactNode } from "react";
import { AnalyticsScreen } from "../features/analytics/AnalyticsScreen";
import { HomeScreen } from "../features/home/HomeScreen";
import { InboxScreen } from "../features/inbox/InboxScreen";
import { LearningsScreen } from "../features/learnings/LearningsScreen";
import { NewJobScreen } from "../features/new/NewJobScreen";
import { NotificationsScreen } from "../features/notifications/NotificationsScreen";
import { PublishScreen } from "../features/publish/PublishScreen";
import { ScheduleScreen } from "../features/publish/ScheduleScreen";
import { ReviewScreen } from "../features/review/ReviewScreen";
import { AccountsScreen } from "../features/settings/AccountsScreen";
import { QueuesScreen } from "../features/settings/QueuesScreen";
import { SettingsScreen } from "../features/settings/SettingsScreen";
import { SeriesScreen } from "../features/studio/SeriesScreen";
import { StudioListScreen } from "../features/studio/StudioListScreen";
import { EmptyState, PageHeader } from "../components/ui";
import { Link, matchPath } from "./router";

type Route = { pattern: string; title: string; wide?: boolean; render: (p: Record<string, string>) => ReactNode };

export const ROUTES: Route[] = [
  { pattern: "/", title: "", render: () => <HomeScreen /> },
  { pattern: "/new", title: "New job", render: () => <NewJobScreen /> },
  { pattern: "/studio", title: "Studio", render: () => <StudioListScreen /> },
  { pattern: "/studio/:id", title: "Studio conversation", render: (p) => <SeriesScreen key={p.id} seriesId={p.id!} /> },
  { pattern: "/learnings", title: "Learnings", wide: true, render: () => <LearningsScreen /> },
  { pattern: "/notifications", title: "Notifications", wide: true, render: () => <NotificationsScreen /> },
  { pattern: "/review/:versionId", title: "Review", wide: true, render: (p) => <ReviewScreen key={p.versionId} versionId={p.versionId!} /> },
  { pattern: "/publish", title: "Publish", wide: true, render: () => <PublishScreen /> },
  { pattern: "/publish/schedule", title: "Schedule", render: () => <ScheduleScreen /> },
  { pattern: "/inbox", title: "Inbox", render: () => <InboxScreen /> },
  { pattern: "/analytics", title: "Analytics", wide: true, render: () => <AnalyticsScreen /> },
  { pattern: "/settings", title: "Settings", render: () => <SettingsScreen /> },
  { pattern: "/settings/accounts", title: "Accounts", render: () => <AccountsScreen /> },
  { pattern: "/settings/queues", title: "Queues", render: () => <QueuesScreen /> },
];

export function resolveRoute(path: string): { element: ReactNode; title: string; wide?: boolean } {
  for (const r of ROUTES) {
    const params = matchPath(r.pattern, path);
    if (params) return { element: r.render(params), title: r.title, wide: r.wide };
  }
  return {
    title: "Not found",
    element: <div className="stack-lg"><PageHeader title="This page doesn't exist" /><EmptyState icon="alert" title="Nothing here" action={<Link to="/" className="btn btn-secondary btn-md">Go home</Link>}>The link may be out of date.</EmptyState></div>,
  };
}
